import axios from 'axios';
function insecureAPI() {
  return axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}`,
    headers: { 'Content-Type': 'application/json'}    
  });
}
function secureAPI(){
  return axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },    
  });
}
function secureUploadAPI() {
  return axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}`,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
  });
}
export { insecureAPI, secureAPI, secureUploadAPI };